import { ButtonGroup } from "@components/button";
import { IconButtonStyledToggle } from "@components/collapsibleSection/CollapsibleSection.styles";
import { Title } from "@components/formGroup";
import { GroupHeader } from "@components/formGroup/GroupHeader";
import { VariableSizeList } from "react-window";
import styled, { css } from "styled-components";

import { T_PLAIN_small_hig } from "../../global.style";
import { VIEW_PADDING_VALUE } from "../View.styles";


export const VariableSizeListStyled = styled(VariableSizeList)`
    scrollbar-width: thin;
`;

export const StyledVirtualizedFormSearch = styled.div`
    display: flex;
    flex-flow: row nowrap;
    background-color: ${props => props.theme.C_BG_floorplan};
    padding-bottom: 24px;
    justify-content: left;
    align-items: center;
`;

export const ResultCounter = styled.div`
    margin: 0 6px 0 24px;
`;

export const FixedSearchWrapper = styled.div<{ $visible: boolean }>`
    display: ${props => props.$visible ? "block" : "none"};
    position: absolute;
    top: 0; left: 0; right: ${VIEW_PADDING_VALUE}px /* some space not to cover scrollbar */;
    padding: 20px 0 0 ${VIEW_PADDING_VALUE}px;
    z-index: 1;
    background-color: ${props => props.theme.C_BG_floorplan};
`;

export const ButtonGroupStyled = styled(ButtonGroup)`
    padding-top: 3px;
    width: 100%;
    max-width: 845px;
`;

export const GroupHeaderWrapper = styled.div<{ $isSubGroup: boolean }>`
    width: 100%;
    max-width: 845px;
    display: flex;
    flex-direction: column;
    padding: 13px 0;
    
    ${IconButtonStyledToggle} {
        order: -1;
        margin-left: 0; margin-right: 6px;
    }
    
    & > :first-child ${Title} {
        ${props => props.$isSubGroup && css`
            ${T_PLAIN_small_hig};
            text-transform: none;
            color: ${props.theme.C_ACT_main};
        `}
    }
`;

export const GroupHeaderStyled = styled(GroupHeader)`
    width: 100%;
    height: 31px;
`;